import React from 'react';

export default function ProductImage({className = '', ...props}) {
  return (
    <img
      className={className}
      src="https://cdn.foodrevolution.org/hhc/hhc-product-image-v2b.png"
      width="1200"
      height="667"
      alt="Healthy Heart Course graphic"
    />
  );
}
